import React from 'react';
import './component.css';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from "@mui/material/Button";
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import { useNavigate } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";

const UpdateBankDetailsComponent = (props) => {
  const navigate = useNavigate();
  const goback = () => navigate(-1);

  return (
    <div className="main-layout">
      <Sidebar />
      <div className="bank-page-container">
        <div className="bank-page-header">
          <h2>
            <img
              onClick={goback}
              className="back-arrow"
              src={leftArrow}
              alt="Back"
            />
            Edit Bank Details
          </h2>
        </div>

        <div className="bank-form-wrapper">
        <div className="bank-form">
  <div className="form-field">
    <TextField
      fullWidth
      label="Account Name"
      name="accountName"
      value={props.formDataBank?.accountName || ''}
      onChange={props.handleChangeUpdateBankDetails}
      InputLabelProps={{ shrink: !!props.formDataBank?.accountName }}
    />
  </div>
  <div className="form-field">
    <TextField
      fullWidth
      label="Account Number"
      name="accountId"
      value={props.formDataBank?.accountId || ''}
      onChange={props.handleChangeUpdateBankDetails}
      InputLabelProps={{ shrink: !!props.formDataBank?.accountId }}
    />
  </div>
  <div className="form-field">
    <TextField
      fullWidth
      label="IFSC"
      name="ifsc"
      value={props.formDataBank?.ifsc || ''}
      onChange={props.handleChangeUpdateBankDetails}
      InputLabelProps={{ shrink: !!props.formDataBank?.ifsc }}
    />
  </div>
</div>


          <div className="bank-buttons">
            <Button variant="outlined" className="bank-btn" onClick={goback}>
              Back
            </Button>
            <Button  variant='contained' className="bank-btn" onClick={props.handleUpdateBankDetails}>
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateBankDetailsComponent;
